<template>
	<div v-if="display_footer" class="total-footnote">
		<button v-if="!footer_expanded" type="button" class="total-footnote-toggle" @click="footer_expanded = true">
			{{ __("About the estimated setup time") }} · {{ __("Read") }}<sup class="total-note-marker">**</sup>
		</button>
		<!-- One __() per line, each with its own row in this app's CSVs. The "**" marker
		     stays outside the key: it ties the note to the "Setup time" total. -->
		<div v-else class="small text-muted">
			<div>**{{ __("The installation time is indicative but is an estimate for a simple standard installation by your chosen VAR Expert.") }}</div>
			<div>{{ __("In this order, you do not commit to this non valued part.") }}</div>
			<div>{{ __("An audit of your activity, a flow analysis, and a set of specifications will allow you to adjust this indicative time.") }}</div>
			<div>{{ __("(Expect significant variations in time depending on the requests or needs).") }}</div>
			<div>{{ __("Your chosen VAR Expert will propose a training plan, here not included, according to the teams and functions.") }}</div>
			<div>{{ __("Standard reports are provided but usually need to be adapted. This time is not counted in the implementation time.") }}</div>
			<div>{{ __("If there are modules offered for free or included, they also require installation and training time.") }}</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
	subscription_items: {
		type: Array,
		required: true
	}
})

// Collapsed by default - shows the compact "About the estimated setup time · Read"
// line; clicking it swaps to the full note.
const footer_expanded = ref(false)

// .some(), not .filter(): .filter() always returns an array (truthy), so the
// predicate this replaces never actually tested anything - the note showed on
// every cart, including carts with no setup-time products. The carttype ==
// 'shopping-cart' arm is gone with it: this component is column-agnostic and the
// caller decides where it renders.
//
// Unguarded dereference is safe by contract: subscription_items is a required
// Array prop, and every call site sits behind the column's v-if="count".
const display_footer = computed(() =>
	props.subscription_items.some(f => f.estimated_setup_time > 0)
)

</script>